import React, { useCallback, useState } from "react";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import { useHistory , useLocation} from "react-router-dom";
import { connect } from "react-redux";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import themeStyle from "../../assets/jss/eclipse/components/themeStyle.js";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from "../../components/CustomButtons/Button.js";
import formStyle from "../../assets/jss/eclipse/components/formStyle.js";
import Danger from "../../components/Typography/Danger.js";
import FormattedAmount from "../../formattedAmount.js";
import { AmountTextField } from "../../components/Amount/AmountTextField.js";
import { ReactComponent as PayshapInfo1Icon } from "../../assets/img/payshap_info_1.svg";
import { ReactComponent as PayshapInfo2Icon } from "../../assets/img/payshap_info_2.svg";
import { ReactComponent as PayshapInfo3Icon } from "../../assets/img/payshap_info_3.svg";
import { ReactComponent as PayshapInfo4Icon } from "../../assets/img/payshap_info_4.svg";
import { ReactComponent as PayshapInfo5Icon } from "../../assets/img/payshap_info_5.svg";
import { ReactComponent as PayshapInfo6Icon } from "../../assets/img/payshap_info_6.svg";
import { ReactComponent as CrossIcon } from "../../assets/img/orange_cross.svg";
import { Dialog } from "@material-ui/core";
import { primaryIconColor } from "../../style.scss";


const useStyles = makeStyles(themeStyle);
const ValidationTextField = withStyles(formStyle)(TextField);

export function GetPaidPayshapAmount(props) {
  const pageState = useLocation().state;
  const template = props?.appData?.template;
  const bankList = (props?.appData?.template?.bankList && props?.appData?.template?.bankList.length > 0) ? props?.appData?.template?.bankList : [];
  const history = useHistory();
  const classes = useStyles();
  const [inputs, setInputs] = useState({ mobileNumber: pageState ? pageState?.mobileNumber : '', bankCode: pageState ? pageState?.bankCode : '', amount: pageState ? pageState?.amount : '', reference: pageState ? pageState?.reference : '' });
  const [errors, setErrors] = useState({});
  const [pastedAmount, setPastedAmount] = useState(0);
  const [open, setOpen] = React.useState(false);
  const defaultMobileNumberRegEx = template?.defaultMobileNumberRegEx;
  const sortedBankList = [...bankList].sort((a, b) => a.name.localeCompare(b.name));

  const handleInputAmountPaste = (event) => {
    event.persist();
    let pastedData = (event.clipboardData || window.clipboardData).getData('text');
    let formattedData = FormattedAmount(pastedData, 'PASTE');
    inputs['amount'] = formattedData;
    if (formattedData > 0) {
      setPastedAmount(inputs?.amount);
    }
    const validationErrors = validateQRForm(inputs);
    setErrors(validationErrors);
  }

  const handleInputChange = (event) => {
    event.persist();
    if (event.target.name === 'amount') {
      if (pastedAmount > 0) {
        inputs['amount'] = pastedAmount;
        setPastedAmount(0);
      } else {
        inputs['amount'] = FormattedAmount(event.target.value);
      }
    } else {
      inputs[event.target.name] = event.target.value;
    }
    setInputs(inputs);
    const validationErrors = validateQRForm(inputs);
    setErrors(validationErrors);
  }

  const handleInputKeyUp = (event) => {
    event.persist();
    if (event.key === ',' && event.target.name === 'amount') {
      inputs['amount'] = FormattedAmount(event.target.value);
      setInputs(inputs);
    }
    const validationErrors = validateQRForm(inputs);
    setErrors(validationErrors);
  }

  const validateQRForm = (inputs) => {
    const errors = {}
    const pattern = new RegExp(defaultMobileNumberRegEx);

    if (!inputs.bankCode) {
      errors.bankCode = 'Your bank is required'
    }

    if (!inputs.mobileNumber) {
      errors.mobileNumber = 'The mobile number is required'
    } else if (!pattern.test(inputs.mobileNumber)) {
      errors.mobileNumber = 'Mobile number is invalid!'
    }

    if (!inputs.amount) {
      errors.amount = 'The amount is required'
    } else if (!/^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d{2})?$/i.test(inputs.amount)) {
      errors.amount = 'Invalid amount!'
    }

    if (inputs.reference) {
      if (!/^[A-Za-z0-9]+[ A-Za-z0-9]{4,}$/i.test(inputs.reference)) {
        errors.reference = 'Reference should be 5 - 20 characters'
      }
    }

    return errors
  }

  const backToTransact = useCallback(() => {
    history.push('/pages/transact');
  },[history]);

  React.useEffect(() => {
    return () => {
      window.onpopstate = () => {
        backToTransact();
      }
    };
  }, [backToTransact])

  const handleQRFormSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validateQRForm(inputs);
    const noErrors = Object.keys(validationErrors).length === 0;
    setErrors(validationErrors);
    if (noErrors) {
      history.push({
        pathname: "/pages/qr-display-payshap",
        state: { ...inputs }
      });
    }
  }

  const handleHowItWork = () => {
    setOpen(true);
  }

  const closeDialog = () => {
    setOpen(false)
  }

  const instructions = [
    {
      icon: <PayshapInfo1Icon />,
      text: "Register for PayShap on your bank's app or online banking"
    },
    {
      icon: <PayshapInfo2Icon />,
      text: "You can register your mobile number with more than one bank"
    },
    {
      icon: <PayshapInfo3Icon />,
      text: "Your mobile number will be your ShapID to receive payment"
    },
    {
      icon: <PayshapInfo4Icon />,
      text: "Once set up, you can generate a QR by entering your mobile number and selecting the bank you want to get paid in"
    },
    {
      icon: <PayshapInfo5Icon />,
      text: "You can show or download and share the QR code with your payor to scan and pay."
    },
    {
      icon: <PayshapInfo6Icon />,
      text: "The payment will reflect in your bank account in seconds."
    }
  ]

  return (
    <div>
      <Dialog open={open}>
        <div style={{ float: 'left', width: '100%', padding: '20px', boxSizing: 'border-box' }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p className={classes.regularFontSize + ' ' + classes.textLeft + ' m-t-0'}><b>How to receive payment with a PayShap QR code</b></p>
            <div onClick={closeDialog} style={{ cursor: "pointer" }}><CrossIcon stroke={primaryIconColor} /></div>
          </div>
          <div>
            {instructions?.map((item, index) => {
              const isLast = instructions.length - 1 === index;
              return (
                <div key={index}>
                  <div style={{ display: "flex", gap: "12px" }}>
                    <p className={classes.regularFontSize + ' ' + classes.textLeft}>{item?.icon}</p>
                    <p className={classes.regularFontSize + ' ' + classes.textLeft}>{item?.text}</p>
                  </div>
                  {!isLast && <div style={{ width: "100%", border: "1px solid #00000012" }}></div>}
                </div>
              )
            })}
          </div>
        </div>
      </Dialog>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ display: 'flex' }}>
              <ArrowBackIosIcon className={classes.linkColor} onClick={backToTransact}></ArrowBackIosIcon>
              <span className={classes.title}>Get paid with a PayShap QR code</span>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridItem xs={12} sm={12} md={12}>
            <p className={classes.regularFontSize + ' ' + classes.textLeft + ' m-b-0'}><b>Enter payment details</b></p>
          </GridItem>
          <form onSubmit={handleQRFormSubmit}>
            <GridItem xs={12} sm={12} md={12}>
              <ValidationTextField
                inputProps={{ inputMode: 'tel' }}
                fullWidth
                label="Mobile number"
                variant="filled"
                id="mobileNumber"
                type="text"
                autoFocus
                error={!!(errors.mobileNumber)}
                name="mobileNumber"
                value={inputs.mobileNumber}
                onChange={handleInputChange}
                onKeyUp={handleInputKeyUp} />
              {errors.mobileNumber && <Danger><small>{errors.mobileNumber}</small></Danger>}
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <ValidationTextField
                fullWidth
                label="Select your bank account"
                select
                variant="filled"
                id="bankCode"
                type="number"
                error={!!(errors.bankCode)}
                name="bankCode"
                value={inputs.bankCode}
                onChange={handleInputChange}
                onKeyUp={handleInputKeyUp}>
                {sortedBankList?.map((bank) => {
                  return (<MenuItem key={bank?.name + '=>#' + bank?.code}
                    value={bank?.name}>{bank?.name}</MenuItem>)
                })}
              </ValidationTextField>
              {errors.bankCode && <Danger><small>{errors.bankCode}</small></Danger>}
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <AmountTextField
                {...props?.appData}
                inputs={inputs}
                errors={errors}
                onPaste={handleInputAmountPaste}
                onChange={handleInputChange}
                onKeyUp={handleInputKeyUp} />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <ValidationTextField
                inputProps={{ maxLength: 20 }}
                fullWidth
                label="Payment reference (Optional)"
                variant="filled"
                id="reference"
                type="text"
                error={!!(errors.reference)}
                name="reference"
                value={inputs.reference}
                onChange={handleInputChange}
                onKeyUp={handleInputKeyUp} />
              {errors.reference && <Danger><small>{errors.reference}</small></Danger>}
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <Button className={classes.buttonRadius} size="lg" block color="primary" type="submit"
                disabled={(errors.receiveWallet || errors.amount || errors.reference) ? true : false}>Generate
                QR code</Button>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <p className={classes.regularFontSize + ' ' + classes.textCenter}>New to PayShap?
                <span className={classes.linkColor} onClick={handleHowItWork}> See how it works</span></p>
            </GridItem>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  )
}


const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

export default connect(mapStateToProps)(GetPaidPayshapAmount)
